<groundworks-card>
  <groundworks-card-body>
    <div class="attachments-section">
      <div class="attachments-header d-flex align-items-center justify-content-between mb-3">
        <div class="d-flex align-items-center gap-3">
          <h2 class="card-title h4 m-0">Attachments</h2>
          <select class="form-select attachments-filter" [ngModel]="selectedSection()"
            (ngModelChange)="selectSection($event)">
            <option [ngValue]="null">All Sections</option>
            @for (section of availableSections(); track section.id) {
            <option [ngValue]="section.id">{{ section.name }}</option>
            }
          </select>
        </div>
        <button class="btn btn-link p-0 text-dark" type="button" (click)="toggleCollapsed()"
          [attr.aria-expanded]="!isCollapsed()" aria-label="Toggle attachments">
          <i class="bi" [class.bi-chevron-up]="!isCollapsed()" [class.bi-chevron-down]="isCollapsed()"></i>
        </button>
      </div>

      @if (!isCollapsed()) {
      <ul class="nav nav-tabs mb-3 align-items-center">
        <li class="nav-item">
          <button type="button" class="nav-link" [class.active]="activeTab() === 'documents'"
            (click)="selectTab('documents')">
            Documents ({{ documentsCount() }})
          </button>
        </li>
        <li class="nav-item">
          <button type="button" class="nav-link" [class.active]="activeTab() === 'pictures'"
            (click)="selectTab('pictures')">
            Pictures ({{ picturesCount() }})
          </button>
        </li>
        <li class="nav-item ms-auto">
          <div class="btn-group" role="group" aria-label="View mode">
            <button type="button" class="btn btn-sm btn-outline-secondary" [class.active]="viewMode() === 'grid'"
              [attr.aria-pressed]="viewMode() === 'grid'" (click)="setViewMode('grid')" aria-label="Grid view">
              <i class="bi bi-grid-3x3" aria-hidden="true"></i>
            </button>
            <button type="button" class="btn btn-sm btn-outline-secondary" [class.active]="viewMode() === 'list'"
              [attr.aria-pressed]="viewMode() === 'list'" (click)="setViewMode('list')" aria-label="List view">
              <i class="bi bi-list" aria-hidden="true"></i>
            </button>
          </div>
        </li>
      </ul>

      @switch (state()) {
      @case ('loading') {
      <groundworks-state-message type="loading" message="Loading attachments..." class="d-flex" />
      }
      @case ('error') {
      <groundworks-state-message type="error" message="Error loading attachments." class="d-flex" />
      }
      @case ('no-matches') {
      <p class="text-muted">
        @if (activeTab() === 'pictures') {
        No pictures found.
        } @else {
        No documents found.
        }
      </p>
      }
      @case ('matches') {
      @if (totalPages() > 1) {
      <div class="d-flex align-items-center justify-content-between mb-3">
        <span class="text-muted small" data-testid="attachments-range">{{ rangeLabel() }}</span>
        <groundworks-pagination [currentPage]="effectivePage()" [totalPages]="totalPages()"
          [maxVisiblePages]="5" [showEllipsis]="true" (pageChange)="onPageChange($event)" />
      </div>
      }
      <div #attachmentsScroll class="attachments-scroll overflow-auto mb-3" data-testid="attachments-scroll">
        @if (viewMode() === 'grid') {
        <div class="attachments-grid d-flex flex-wrap gap-3">
          @for (attachment of pagedItems(); track attachment.id) {
          <groundworks-image-tile [tile]="toImageTile(attachment)" (tileClick)="onTileClick(attachment)" />
          }
        </div>
        } @else {
        <groundworks-card [cardClasses]="['shadow-none']" [constrained]="true">
          <groundworks-card-body>
            <groundworks-table [data]="attachmentsListTableData()" />
          </groundworks-card-body>
        </groundworks-card>
        }
      </div>
      }
      }
      }
      <div class="d-flex justify-content-end">
        <button class="btn btn-primary" (click)="onAddAttachment()">Upload File</button>
      </div>
    </div>
  </groundworks-card-body>
</groundworks-card>
